import { Theme } from '@mui/material'

import {
  EChatbotTheme,
  TChatbotSettingsLayout,
} from '~/features/settings/models'

export const getLayoutColors = (
  chatbotLayout: TChatbotSettingsLayout,
  theme: Theme,
) => {
  const wrapperBackgroundColor =
    chatbotLayout.selection.theme === EChatbotTheme.linkView
      ? chatbotLayout.options[chatbotLayout.selection.theme][
          chatbotLayout.selection[chatbotLayout.selection.theme]
        ].mainBackgroundColor
      : chatbotLayout.selection[EChatbotTheme.simple]
  const containerBackgroundColor =
    chatbotLayout.selection.theme === EChatbotTheme.linkView
      ? chatbotLayout.options[chatbotLayout.selection.theme][
          chatbotLayout.selection[chatbotLayout.selection.theme]
        ].mainBackgroundColor
      : theme.palette.common.white

  return { wrapperBackgroundColor, containerBackgroundColor }
}

export default getLayoutColors
